import Component from "@base/js/component";

export default class SocialAndPrint extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".social-and-print";

  // Defines children that needs to be queried as part of this component
  static children = {
    shareToggle: ".social-and-print__share",
    print: ".social-and-print__print",
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    // subComponent: ComponentClass, // Maps as a single subcomponent instance
    // subComponents: [ComponentClass], // Maps as an array of subcomponent instances
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    shareToggle: {
      click: this.toggleShareIcons,
    },
    print: {
      click: this.print,
    },
  };

  // constructor() {
  //   super();
  // }

  toggleShareIcons(e) {
    e.preventDefault();
    this.element.classList.toggle("social-and-print--expanded");
  }

  print(e) {
    e.preventDefault();
    window.print();
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
SocialAndPrint.init();
